import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { SCREENS, SUB_SCREENS } from '../../../constants/Tracking';
import { View } from 'foundations-components/components/View';
import { RankedRecommendationsWithNegativeFeedback } from '../../recommendations/components/RankedRecommendationsWithNegativeFeedback';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { jsx as _jsx } from "react/jsx-runtime";
export const LessonRecommendationsPage = ({
  id,
  name
}) => {
  usePageTitle({
    i18nKey: 'learningCenter.pageTitles.recommendations'
  });
  const {
    isLaptop
  } = useMediaQuery();
  useEffect(() => {
    UsageTracker.trackStandalone('Pageview', {
      screen: SCREENS.LESSON,
      subscreen: SUB_SCREENS.RECOMMENDATIONS,
      lessonId: id
    });
  }, [id]);
  const handleOnItemClick = (item, index) => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'lesson-end-recommendation-card-click',
      cardNumber: index + 1,
      lessonId: id,
      recommendationType: 'ranked'
    });
  };
  return /*#__PURE__*/_jsx(View, {
    padding: "700",
    children: /*#__PURE__*/_jsx(RankedRecommendationsWithNegativeFeedback, {
      appearsIn: "lesson-recommendations",
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInterstitials.recommendations.lessonRecommendations.body",
        options: {
          lessonName: name
        }
      }),
      direction: isLaptop ? 'column' : 'row',
      header: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.lessonInterstitials.recommendations.lessonRecommendations.heading"
      }),
      inferenceSource: "LESSON_RECOMMENDATIONS",
      onItemClick: handleOnItemClick,
      resultTypes: ['LESSON'],
      size: isLaptop ? 'small' : 'large'
    })
  });
};